export default "/fonts/Urbanist-Regular.ttf?0b2ce1ceae32e92108a2eaa8fa541b2d";